import { callDecimal } from "../utils.ts";
import { SystemKind } from "../common-types/kind.ts";
import { Condition, ProductAvailability, ProductSource } from "./product.ts";

export interface CartPrice {
  // e.g. 5195
  cents: number;
  // e.g. "$51.95"
  currency: string;
  // e.g. "51.95"
  float: string;
}

export interface CartItemBiod {
  availabilityChanged: boolean;
  // Unused. Should be number?
  // availableQuantity: string;
  bookbinId: string;
  comments: string | null;
  location: string;
  priceChanged: boolean;
  productId: string;
  purchaseType: unknown; // "purchase"
  quality: string; // e.g. "very good", likely want to capitalize for display
  quantity: number;
  // Unused. Should be number?
  // reservedQuantity: string;
  returnable: false;
  sellerName: string;
  shippingDaysMax: number;
  shippingDaysMin: number;
  // e.g. 4.5
  unitCost: number;
  // e.g 5.62
  unitPriceRaw: number;
}

export interface CartItem {
  id: number;
  /**
   * Print items should have biod nodes
   */
  biod: CartItemBiod | null;
  canonicalIsbn: string;
  condition: Condition | null;
  coverUrl: string;
  // e.g. "2025-05-01T16:56:04.000Z"
  createdAt: string;
  deliveryMethod: "code" | "bookshelf";
  // In days, 0 = perpetual
  downloadableDuration: number;
  // e.g. 1st, 2nd
  edition: string;
  // e.g. 2025-02-21T18:42:15.921Z
  // Will be today if perpetual
  expiration: string;
  initialPrice: CartPrice;
  markupCategory: unknown;
  // This probably isn't what you want
  onlineDuration: number;
  price: CartPrice;
  productAvailability: ProductAvailability;
  quantity: number;
  sku: string;
  source: ProductSource | null;
  subtitle?: string;
  subtotal: CartPrice;
  taxCategory: string;
  title: string;
  type: SystemKind;
  // e.g. "2025-05-01T16:56:04.000Z"
  updatedAt: string;
}

export interface Cart {
  biod: {
    // e.g. "2025-05-01T16:56:04.000Z"
    createdAt: string;
    // e.g. "2025-05-01T16:56:04.000Z"
    expiresAt: string;
    tbxCartId: number;
    // e.g. "2025-05-01T16:56:04.000Z"
    updatedAt: string;
    vstCartId: string;
  };
  containsShippableItems: boolean;
  countryAbbreviation: string;
  // e.g. "2025-05-01T16:56:04.000Z"
  createdAt: string;
  // e.g. "usd"
  currencyLabel: string;
  currencySymbol: string;
  lineItems: CartItem[];
  subtotal: CartPrice;
  totalQuantity: number;
  // e.g. "2025-05-01T16:56:04.000Z"
  updatedAt: string;
}

export function getCart() {
  return callDecimal<Cart>("/api/v1/users/carts");
}

export function updateQuantity(cartItemId: number, quantity: number) {
  return callDecimal(`/api/v1/line_items/${cartItemId}`, {
    method: "PATCH",
    body: JSON.stringify({
      quantity,
    }),
  });
}

export function deleteItem(cartItemId: number) {
  return callDecimal(`/api/v1/line_items/${cartItemId}`, {
    method: "DELETE",
  });
}

export function addToCart(
  variantId: number,
  quantity: number,
  productId?: string
) {
  return callDecimal<Cart>("/api/v1/line_items", {
    method: "POST",
    body: JSON.stringify({
      variant_id: variantId,
      quantity,
      product_id: productId,
    }),
  });
}
